// If JS is not available expand the collapsible sections
const loadCollapsibleSections = () => {
  const collapsible = document.querySelector('.collapsible');

  if (collapsible) {
    const headings = collapsible.querySelectorAll('h2');
    headings.forEach((heading) => {
      const panelToActivate = heading.parentNode;

      panelToActivate
        .querySelector('button')
        .setAttribute('aria-expanded', false);

      panelToActivate
        .querySelector('.collapsible-content')
        .setAttribute('aria-hidden', true);
    });
  }
};

// expand collapse on button click
const collapsibleSections = () => {
  const collapsible = document.querySelector('.collapsible');

  if (collapsible) {
    const headings = collapsible.querySelectorAll('h2');
    headings.forEach((heading) => {
      const btn = heading.querySelector('button');
      const panelToActivate = heading.parentNode;

      if (btn) {
        btn.addEventListener('click', () => {
          const activePanelIsOpened = btn.getAttribute('aria-expanded');
          if (activePanelIsOpened === 'true') {
            panelToActivate
              .querySelector('button')
              .setAttribute('aria-expanded', false);

            panelToActivate
              .querySelector('.collapsible-content')
              .setAttribute('aria-hidden', true);
          } else {
            panelToActivate
              .querySelector('button')
              .setAttribute('aria-expanded', true);

            panelToActivate
              .querySelector('.collapsible-content')
              .setAttribute('aria-hidden', false);
          }
        });
      }
    });
  }
};

// trigger in case of a page reload upon error
const expandAll = () => {
  const collapsibleExpand = document.querySelector('.collapsible.expand-all');

  if (collapsibleExpand) {
    const collapsible = document.querySelector('.collapsible');
    const headings = collapsible.querySelectorAll('h2');

    headings.forEach((heading) => {
      const btn = heading.querySelector('button');
      const panelToActivate = heading.parentNode;

      if (btn) {
        panelToActivate
          .querySelector('button')
          .setAttribute('aria-expanded', true);

        panelToActivate
          .querySelector('.collapsible-content')
          .setAttribute('aria-hidden', false);
      }
    });
  }
};

// in case submit is clicked before a require input is filled in expand all
const form = document.querySelector('#mc10wForm');
const collapsibleExpand = document.querySelector('.collapsible');

if (form && collapsibleExpand) {
  form.addEventListener('invalid', () => {
    collapsibleExpand.classList.add('expand-all');
    expandAll();
  }, true);
}

window.addEventListener('DOMContentLoaded', () => {
  loadCollapsibleSections();
  collapsibleSections();
  expandAll();
});
